import TermsNavList from './TernsNavList';

function TermsSection(props: { title: string; children: JSX.Element }) {
  return (
    <div className="flex flex-col gap-4">
      <div className="font-extrabold text-[50px] lg:text-[70px] text-defaultDark">
        {props.title}
      </div>
      <div className="flex flex-col-reverse lg:flex-row gap-8">
        <div className="w-[90%] lg:w-[70%]">{props.children}</div>
        <TermsNavList />
      </div>
    </div>
  );
}

export default TermsSection;
